import { ImageHelpers } from 'helpers/images';
import { TopicManager } from 'managers/topic';
import WCCAttachment from 'models/attachments/attachment';
import WccImage from 'models/attachments/image';
import pattern from 'patterns/cardssort';
import { WCCContentAttachmentsBlock } from '../blocks/attachments/attachments';
import WCCContentContext from '../context';
import WCCContentPatternRule from './pattern';

const displayTypesWithText = [
    0,
    enums.CardSortDisplayTypes.Text.value,
    enums.CardSortDisplayTypes.TextAndImage.value
];

export default class WCCContentCardsSortRule extends WCCContentPatternRule {
    protected pattern = pattern;

    protected process(match: RegExpMatchArray, context: WCCContentContext) {
        const topicManager = context.storage.get(TopicManager, { topicId: context.topicId });
        const topic = topicManager.pluck(m => m.topic);

        const cardsDisplay = topic.pluck('cardSortDisplayType', 0);

        const data = _(this.parseContent(match[1])).defaults({
            items: []
        });

        const attachments = ko.pureComputed(() => (<Array<any>>data.items).map((item: any) => this.getImage(item)));

        return new WCCContentAttachmentsBlock({
            content: match[0],
            attachments: attachments,
            columnWidth: 55,
            rowsCount: 0,
            expand: false,
            showTitle: ko.pureComputed(() => displayTypesWithText.includes(cardsDisplay()))
        });
    }

    private parseContent(content: string) {
        try {
            return JSON.parse(content);
        } catch (e) {
            return {};
        }
    }

    private getImage(item: any): WCCAttachment {
        let fileToken = item.token ?? item.url;

        // fix full url for old card sorts
        if (fileToken && fileToken.indexOf('https') === 0) {
            const fileNameExt = /\/[a-z0-9]*\.[a-z]+[^\/]/;
            const result = fileNameExt.exec(fileToken);
                        
            if (result && result.length > 0)
                fileToken = result[0].substring(1, result[0].indexOf('.')); // remove leading slash and file extension
        }

        const link = fileToken ? `${settings.wccApiUrl}/api/resources/taskimages/${fileToken}` : item.url;

        const wccImage = new WccImage({
            Link: link,
            FileToken: fileToken, // new FileToken for handling image link
            Title: item.title,
            FileType: enums.AttachmentTypes.Image.value,
            IsCardSortImage: true
        });
        
        ImageHelpers.waitImage(ImageHelpers.getImage(link, true)).then(image => {
            wccImage.width(image.width);
            wccImage.height(image.height);
        });

        return wccImage;
    }
}